import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import logoHeader from "../../assets/logo.png";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { buildRouteWithUtms, saveUtmParams } from "../../config/whatsappConfig";
import useFinanciaciones from "../../config/useFinanciaciones";
import { getHeaderOffset, scrollToAnchor } from "../../utils/scrollToAnchor";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
  { label: "Plan de ahorro", sectionId: "plan", route: "/plan" },
];

const CATALOG_SECTIONS = ["convencional", "financiaciones", "plan", "adjudicados"];

const Header = () => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();
  const location = useLocation();
  const history = useHistory();
  const { tipo } = useParams();

  const [activeSection, setActiveSection] = useState("inicio");
  const spyLockUntil = useRef(0);

  const navItems = NAV_ITEMS.filter(
    (item) =>
      item.sectionId !== "financiaciones" || (!loadingFinanciaciones && financiaciones.length > 0),
  );

  useEffect(() => {
    const validTipos = ["todos", "convencional", "plan", "preventa", "adjudicado", "adjudicados"];
    const search = location.search;

    if (!tipo || !validTipos.includes(tipo)) {
      saveUtmParams();
      history.replace(buildRouteWithUtms("/todos", search));
    }
  }, [history, tipo, location.search]);

  const handlePedirPresupuesto = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });
    openConsultaForm();
  };

  useEffect(() => {
    const updateActiveSection = () => {
      if (Date.now() < spyLockUntil.current) return;

      const probe = getHeaderOffset() + 4;
      const catalogStart = document.getElementById("scroll-click");
      const pastHero = Boolean(catalogStart) && catalogStart.getBoundingClientRect().top - probe <= 0;

      if (!pastHero) {
        setActiveSection("inicio");
        return;
      }

      let current = null;

      CATALOG_SECTIONS.forEach((sectionId) => {
        const el = document.getElementById(sectionId);
        if (!el) return;
        if (el.getBoundingClientRect().top - probe <= 0) {
          current = sectionId;
        }
      });

      if (!current) {
        current = CATALOG_SECTIONS.find((sectionId) => document.getElementById(sectionId)) || "inicio";
      }

      setActiveSection(current);
    };

    const onScroll = () => window.requestAnimationFrame(updateActiveSection);

    updateActiveSection();
    const retry = window.setTimeout(updateActiveSection, 400);

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.clearTimeout(retry);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [tipo]);

  const handleNavClick = ({ sectionId, route }) => {
    setActiveSection(sectionId);
    spyLockUntil.current = Date.now() + 1200;

    const search = location.search;
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route, search));
    }

    window.setTimeout(() => {
      scrollToAnchor(sectionId);
    }, currentTipo !== targetTipo ? 80 : 0);
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header">
          <Col lg={3} md={4} xs={12} className="text-sm-start text-center py-2">
            <Link
              to={buildRouteWithUtms("/todos", location.search)}
              onClick={() => {
                setActiveSection("inicio");
                spyLockUntil.current = Date.now() + 1200;
                window.setTimeout(() => scrollToAnchor("inicio"), 80);
              }}
            >
              <img src={logoHeader} alt="Montironi Peugeot" className="header-logo" />
            </Link>
          </Col>
          <Col
            lg={9}
            md={8}
            xs={12}
            className="text-sm-start text-center py-2 justify-content-md-end justify-content-center d-md-flex d-none"
          >
            <nav className="header-nav" aria-label="Navegación principal">
              {navItems.map((item) => (
                <button
                  key={item.sectionId}
                  type="button"
                  className={`link-header border-0 bg-transparent${
                    activeSection === item.sectionId ? " link-header--active" : ""
                  }`}
                  onClick={() => handleNavClick(item)}
                  aria-current={activeSection === item.sectionId ? "true" : undefined}
                >
                  {item.label}
                </button>
              ))}

              <Button className="btn-peugeot-corporate ms-md-2" onClick={handlePedirPresupuesto}>
                Solicitar cotización
              </Button>
            </nav>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;
